/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-05-24T14:53:19.37
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseReformItem,
	listRentHouseReformItemInit,
	listRentHouseReformItemByAuthorizations,
	deleteRentHouseReformItem
} from '@api/rentmanage/RentHouseReformItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseReformItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseReformItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseReformItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseReformItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseReformItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseReformItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseReformItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseReformItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
